import React, { useState, useRef, useCallback } from "react";
import AppIcon from "../../../components/ui/AppIcon";
import "./ThreadPanel.css";

export default function ThreadComposer({
  onSend,
  onTypingStart,
  onTypingStop,
}) {
  const [content, setContent] = useState("");
  const typingTimeoutRef = useRef(null);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!content.trim()) return;

      onSend(content);
      setContent("");
      onTypingStop?.();
    },
    [content, onSend, onTypingStop],
  );

  const handleChange = useCallback(
    (e) => {
      setContent(e.target.value);

      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      onTypingStart?.();
      typingTimeoutRef.current = setTimeout(() => {
        onTypingStop?.();
      }, 2000);
    },
    [onTypingStart, onTypingStop],
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        handleSubmit(e);
      }
    },
    [handleSubmit],
  );

  return (
    <form className="thread-composer" onSubmit={handleSubmit}>
      <input
        type="text"
        value={content}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Reply in thread..."
        className="thread-composer-input"
      />
      <button
        type="submit"
        className="thread-composer-send"
        disabled={!content.trim()}
      >
        <AppIcon name="PaperAirplaneIcon" size={18} />
      </button>
    </form>
  );
}
